export default "__VITE_ASSET__bccc70e1__"